export default __webpack_public_path__ + "static/media/car.c7901a43.png";